import React from 'react';
import Hero from '../components/Hero';
import Categories from '../components/Categories';
import Providers from '../components/Providers';
import { StatsMarquee, TrustBadge, CoverageSection, AppSection } from '../components/HomeSections';
import Testimonials from '../components/Testimonials';
import { CitiesSection, BecomeProviderSection } from '../components/CitiesSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div>
      <Hero />
      <Categories />
      <Providers />
      <StatsMarquee />
      <TrustBadge />
      <CoverageSection />
      <AppSection />
      <Testimonials />
      <CitiesSection />
      <BecomeProviderSection />
      <Footer />
    </div>
  );
};

export default HomePage;
